import React from "react";
import "./Intro.scss";

function Intro({ caption }) {
  return (
    <div className="block-intro">
      <div className="grid">
        <div className="col caption">
          <p>{caption}</p>
        </div>
      </div>
    </div>
  );
}

export default Intro;
